import { useEffect, useState } from 'react';
import { platformApi } from '../lib/api.js';

export default function PlatformHealth() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const tick = () => platformApi.health().then(setD).catch(() => {});
    tick();
    const i = setInterval(tick, 5000);
    return () => clearInterval(i);
  }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Health</h1>
      <div className="grid sm:grid-cols-2 gap-3">
        <Card title="App pool (RLS-enforced)" stats={d.appPool} />
        <Card title="Admin pool (BYPASSRLS)" stats={d.adminPool} />
      </div>
      <div className="bg-white border border-slate-200 rounded p-4">
        <h2 className="font-semibold mb-2">Process</h2>
        <ul className="text-sm space-y-1">
          <li>uptime: <span className="font-mono">{d.process.uptime_seconds}s</span></li>
          <li>memory rss: <span className="font-mono">{d.process.memory_rss_mb} MB</span></li>
          <li>node: <span className="font-mono">{d.process.node_version}</span></li>
        </ul>
      </div>
    </div>
  );
}
function Card({ title, stats }) {
  return (
    <div className="bg-white border border-slate-200 rounded p-4">
      <h2 className="font-semibold mb-2">{title}</h2>
      {stats?.note ? (
        <div className="text-sm text-slate-500 italic">{stats.note}</div>
      ) : (
        <ul className="text-sm space-y-1">
          <li>total: <span className="font-mono">{stats?.total ?? '—'}</span></li>
          <li>idle: <span className="font-mono">{stats?.idle ?? '—'}</span></li>
          <li>waiting: <span className="font-mono">{stats?.waiting ?? '—'}</span></li>
        </ul>
      )}
    </div>
  );
}
